<template>
    <div style="display: contents;">
        <div class="floatTab flex justify-center items-center ">
            <div class="
            tabItem
            text-center
            cursor-pointer
            body-16_regular
            active
            word1
          ">
                衍生品交易
            </div>
            <div class="tabItem text-center cursor-pointer body-16_regular word2">
                贵金属及能源
            </div>
            <div class="tabItem text-center cursor-pointer body-16_regular word3">
                全球股指
            </div>
            <div class="tabItem text-center cursor-pointer body-16_regular word4">
                美国股票
            </div>
            <div class="tabItem text-center cursor-pointer body-16_regular word5">
                ETF
            </div>
            <!-- <div class="tabItem text-center cursor-pointer body-16_regular word6">
          数字资产
        </div> -->
        </div>
        <div class="mobile scrollTabWrapper ">
            <div class="scrollTab flex justify-center items-center">
                <div class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              active
              word1
            ">
                    衍生品交易
                </div>
                <div class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              word2
            ">
                    贵金属及能源
                </div>
                <div class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              word3
            ">
                    全球股指
                </div>
                <div class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              word4
            ">
                    美国股票
                </div>
                <div class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              word5
            ">
                    ETF
                </div>
                <!-- <div
            class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              word6
            "
          >
            数字资产
          </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
    .container2{
  background:var(--ebc-neutral-bg_a);
  margin-top: -64rem;
}
.pt .floatTab,
.es .floatTab{
  width: 900rem;
}
 .floatTab{
  position: sticky;
  transform:translateY(-50%);
  z-index: 98;
  top:128px;
  margin-inline:auto;
  background:var(--ebc-basecolor-white-85);
  border-radius: var(--ebc-corner-radius-full);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  padding:4rem;
  gap:8rem;
  width: 792rem;
  height:64rem;
}

 .floatTab .tabItem{
  flex:1;
  color: var(--ebc-text-secondary);
}
 .floatTab .active{
    border-radius: var(--ebc-corner-radius-full);
    background: var(--ebc-neutral-bg_c);
    color:var(--ebc-text-primary);
    display:flex;
    align-items: center;
    justify-content: center;
    height:100%;
    font-weight: 500;
}
.container2 .container2Content{
  padding:120rem 0;
}
/* .container2 .container2Content>a:last-of-type{
  display:none!important
} */

.container2 h2 {
  margin-bottom: 16rem;
}
.tradingProductPage .container2 h2{
  max-width: 850rem;
  margin-inline: auto;
}
.container2 h3{
   max-width: 850rem;
  margin-inline: auto!important;
}
.container2 h3{
  margin:16rem 0;
  color:var(--ebc-text-secondary);
}

.container2 .btn{
  margin: 60rem auto 0;
}

@media (max-width: 996px) {
   html {
    height: auto !important;
    min-height: auto !important;
  }
  .container2 {
    padding:0 32rem;
    margin-top: 0;
  }
  .container2 .container2Content .btnTop{
  height:64rem;
  font-size: 28rem;
  gap:8rem;
  line-height: 44rem;
}
   .container2 .btn{
    height:80rem;
    font-size: 28rem;
    line-height: 44rem;
    margin-top: 80rem;
  }
  .floatTab{
    display:none!important;
  }
  .container2 .container2Content{
    padding:64rem 0 160rem;
  }
  .container2 h3{
    margin:16rem 0;
  }
   .scrollTab{
    display: inline-flex;
    gap:16rem;
    min-width: fit-content;
  }
  .scrollTabWrapper{
    overflow-x: auto;
    scroll-behavior: smooth;
    padding:16rem 32rem;
    margin-top: 64rem;
    background: var(--ebc-neutral-bg_a);
    position: sticky;
    top:44px;
    z-index:99
  }
    .scrollTabWrapper::-webkit-scrollbar {
    display: none;
  }
   .scrollTab .tabItem{
    color:var(--ebc-text-secondary);
    padding:16rem 32rem;
    flex:1;
    background: var(--ebc-neutral-bg_b);
    border-radius: var(--ebc-corner-radius-full);
    white-space: nowrap;
  }
   .scrollTab .active{
    background:var(--ebc-basecolor-active-500);
    color:var(--ebc-text-primary_white);
    font-weight: 500;
  }
}

</style>